import { AIEMUserActionType } from '../../aiem/userActions';

export const DAIEngineProfileActions = [
  AIEMUserActionType.DAI_ENGINE_PROFILES_CREATE,
  AIEMUserActionType.DAI_ENGINE_PROFILES_GET,
  AIEMUserActionType.DAI_ENGINE_PROFILES_LIST,
  AIEMUserActionType.DAI_ENGINE_PROFILES_UPDATE,
  AIEMUserActionType.DAI_ENGINE_PROFILES_DELETE,
];

export const H2OEngineProfileActions = [
  AIEMUserActionType.H2O_ENGINE_PROFILES_CREATE,
  AIEMUserActionType.H2O_ENGINE_PROFILES_GET,
  AIEMUserActionType.H2O_ENGINE_PROFILES_LIST,
  AIEMUserActionType.H2O_ENGINE_PROFILES_UPDATE,
  AIEMUserActionType.H2O_ENGINE_PROFILES_DELETE,
];

export const NotebookEngineProfileActions = [
  AIEMUserActionType.NOTEBOOK_ENGINE_PROFILES_CREATE,
  AIEMUserActionType.NOTEBOOK_ENGINE_PROFILES_GET,
  AIEMUserActionType.NOTEBOOK_ENGINE_PROFILES_LIST,
  AIEMUserActionType.NOTEBOOK_ENGINE_PROFILES_UPDATE,
  AIEMUserActionType.NOTEBOOK_ENGINE_PROFILES_DELETE,
];

export const DAIEngineVersionActions = [
  AIEMUserActionType.DAI_ENGINE_VERSION_CREATE,
  AIEMUserActionType.DAI_ENGINE_VERSION_GET,
  AIEMUserActionType.DAI_ENGINE_VERSION_LIST,
  AIEMUserActionType.DAI_ENGINE_VERSION_UPDATE,
  AIEMUserActionType.DAI_ENGINE_VERSION_DELETE,
];

export const H2OEngineVersionActions = [
  AIEMUserActionType.H2O_ENGINE_VERSION_CREATE,
  AIEMUserActionType.H2O_ENGINE_VERSION_GET,
  AIEMUserActionType.H2O_ENGINE_VERSION_LIST,
  AIEMUserActionType.H2O_ENGINE_VERSION_UPDATE,
  AIEMUserActionType.H2O_ENGINE_VERSION_DELETE,
];

export const NotebookEngineImageActions = [
  AIEMUserActionType.NOTEBOOK_ENGINE_IMAGES_CREATE,
  AIEMUserActionType.NOTEBOOK_ENGINE_IMAGES_GET,
  AIEMUserActionType.NOTEBOOK_ENGINE_IMAGES_LIST,
  AIEMUserActionType.NOTEBOOK_ENGINE_IMAGES_UPDATE,
  AIEMUserActionType.NOTEBOOK_ENGINE_IMAGES_DELETE,
];

export const SandboxEngineImageActions = [
  AIEMUserActionType.SANDBOX_ENGINE_IMAGES_CREATE,
  AIEMUserActionType.SANDBOX_ENGINE_IMAGES_GET,
  AIEMUserActionType.SANDBOX_ENGINE_IMAGES_LIST,
  AIEMUserActionType.SANDBOX_ENGINE_IMAGES_UPDATE,
  AIEMUserActionType.SANDBOX_ENGINE_IMAGES_DELETE,
];

export const SandboxEngineTemplateActions = [
  AIEMUserActionType.SANDBOX_ENGINE_TEMPLATES_CREATE,
  AIEMUserActionType.SANDBOX_ENGINE_TEMPLATES_GET,
  AIEMUserActionType.SANDBOX_ENGINE_TEMPLATES_LIST,
  AIEMUserActionType.SANDBOX_ENGINE_TEMPLATES_UPDATE,
  AIEMUserActionType.SANDBOX_ENGINE_TEMPLATES_DELETE,
];
